import { useQuery } from "@tanstack/react-query"

import MetricDisplay from "./MetricDisplay.tsx"
import MetricsCard from "./MetricsCard.tsx"

import type { FlowRateDisplayData } from "../types/flowRateDisplayTypes.ts"

export default function FlowRateDisplay({
  fetcher,
  location,
}: {
  fetcher: () => Promise<FlowRateDisplayData>
  location: number
}) {
  const { data, isPending, isError } = useQuery({
    queryKey: ["flowRateDisplay", { location }],
    queryFn: fetcher,
    refetchInterval: 1000,
  })

  let denominator = 0
  let efficiency = 0

  if (data) {
    denominator = data.inletSCFM * (data.inletCH4 / 100)
    efficiency =
      denominator > 0 ? ((data.outletSCFM * (data.outletCH4 / 100)) / denominator) * 100 : 0
  }

  return (
    <MetricsCard title="Live Metrics">
      <MetricDisplay
        label="Inlet Gas Flow"
        value={data ? data.inletSCFM : 0}
        loading={isPending}
        error={isError}
        unit="SCFM"
      />
      <MetricDisplay
        label="Inlet Methane Content"
        value={data ? data.inletCH4 : 0}
        loading={isPending}
        error={isError}
        unit="%"
      />
      <MetricDisplay
        label="Efficiency"
        loading={isPending}
        error={isError}
        value={efficiency}
        unit="%"
      />
      <MetricDisplay
        label="Methane to Pipeline Flow"
        value={data ? (data.outletSCFM * data.outletCH4) / 100 : 0}
        loading={isPending}
        error={isError}
        unit="SCFM"
      />
    </MetricsCard>
  )
}
